import { TFunction } from 'i18next';
import * as Yup from 'yup';
import { parsePhoneNumberString } from 'shared/utils';
import {
  LinkTypes,
  PhoneNumberRegex,
  PhoneSMSRegex,
  UrlRegex,
} from '../../constants';

export const getLinksValidationSchema = (
  t: TFunction,
): Yup.ArraySchema<Yup.AnyObjectSchema> =>
  Yup.array(
    Yup.object().shape({
      linkType: Yup.string()
        .required(t('formLinks.inputs.linkType.required'))
        .nullable(),
      label: Yup.string().required(t('formLinks.inputs.linkLabel.required')),
      value: Yup.string()
        .when('linkType', (linkType, schema) => {
          if (linkType === LinkTypes.email) {
            return schema.email(t('formLinks.inputs.linkValue.invalid.email'));
          }
          if (linkType === LinkTypes.website) {
            return schema.matches(
              UrlRegex,
              t('formLinks.inputs.linkValue.invalid.url'),
            );
          }
          if (linkType === LinkTypes.phone) {
            return schema
              .transform(parsePhoneNumberString)
              .test(
                'is-phone-or-sms',
                t('formLinks.inputs.linkValue.invalid.phoneNumber'),
                (value: string) => {
                  if (!value) return false;
                  return (
                    PhoneSMSRegex.test(value) || PhoneNumberRegex.test(value)
                  );
                },
              );
          }
          return schema;
        })
        .required(t('formLinks.inputs.linkValue.required')),
    }),
  );
